export const FETCH_EMAIL_DISCOVERY_REQUEST = 'Login/FETCH_EMAIL_DISCOVERY_REQUEST'
export const FETCH_EMAIL_DISCOVERY_SUCCESS = 'Login/FETCH_EMAIL_DISCOVERY_SUCCESS'
export const FETCH_EMAIL_DISCOVERY_FAILURE = 'Login/FETCH_EMAIL_DISCOVERY_FAILURE'
export const FETCH_EMAIL_DISCOVERY_RESET = 'Login/FETCH_EMAIL_DISCOVERY_RESET'

export const FETCH_EMAIL_LINK_REQUEST = 'Login/FETCH_EMAIL_LINK_REQUEST'
export const FETCH_EMAIL_LINK_SUCCESS = 'Login/FETCH_EMAIL_LINK_SUCCESS'
export const FETCH_EMAIL_LINK_FAILURE = 'Login/FETCH_EMAIL_LINK_FAILURE'
